<template>
    <div class="row">
        <div class="col-12 col-md-8">
            <div class="row">
                <div class="col-12">
                    <p>{{ $t('Oled registreeritud järgmistele võistlustele. Osavõtjate nimekirja näed võistluse nimele klikkides.') }}</p>
                    <p>{{ $t('Võistlusdistantsi läbimise järel võid asuda tulemusi lisama.') }}</p>
                </div>
            </div>

            <div class="row my-3" v-if="current().length > 0">
                <div class="col-12">
                    <div class="accordion">
                        <div class="card" v-for="evt in current()">
                            <div class="card-header px-0 py-1" :id="'prtH-' + evt.id">
                                <span class="h5 tab-title mb-0 ml-0 float-left">
                                    {{ evt.is_challenge ? $t('Väljakutse') + ': ' : '' }}{{ evt.name }}
                                </span>
                            </div>

                            <div class="card-body">
                                <div class="row evt-data">
                                    <div class="col-12">
                                        <span>
                                            <i class="fa fa-calendar"></i>
                                            <span>{{ evt._period }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="row evt-data">
                                    <div class="col-12">
                                        <span>
                                            <i class="fa fa-road"></i>
                                            <span v-if="evt.distancesList">{{ evt.distancesList.join(' / ') }}</span>
                                             <span v-else>-</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="row my-1" v-if="evt.$ongoing">
                                    <div class="col-12">
                                        <span>
                                            <strong>{{ $t('Tulemusi saad lisada') }}: {{ evt._periodForResults }}</strong>
                                        </span>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-11">
                                        <a href="" class="btn btn-success btn-lg btn-block text-uppercase" v-on:click.prevent="toggleEvent(evt.id)">
                                            + {{ $t('Lisa tulemus') }}
                                        </a>
                                    </div>
                                </div>

                                <competition :event-id="evt.id"></competition>

                                <div class="row mt-2" v-if="evt.link">
                                    <div class="col-11">
                                        <a :href="evt.link" class="btn btn-secondary btn-lg btn-block text-uppercase">
                                            + {{ $t('Näita osalejaid') }}
                                        </a>
                                        <a :href="evt.link" class="btn btn-secondary btn-lg btn-block text-uppercase">
                                            + {{ $t('Näita tulemusi') }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Competition from './competition';
import MrtApi from '../../mrt-api';

export default {
    name: 'competitions',
    components: {Competition},
    data() {
        return {
            events: []
        };
    },
    mounted() {
        axios.get(MrtApi.createUrl(Mrt.config.routes['account.competitions.api.my']))
            .then(
                (response) => {
                    this.events = response.data.events;
                }
            );
    },
    methods: {
        current() {
            return this.events;
        },
        find(id) {
            return this.events.find(item => item.id === id);
        },
        toggleEvent(id) {
            const evt = this.find(id);
            if (evt) {
                evt.$active = !evt.$active;
                this.emitter.emit('load-competition', evt.id);
            }
        }
    },
};
</script>

<style scoped>

</style>
